import type { AuthedAxiosRequests } from 'features/auth'
import { z } from 'zod'

const STABLE_ORDER = [{ field: 'id', descending: false }]
const rowsSchema = z.array(z.unknown())

type LotoLoadQuery = {
  type: string[]
  tags: Record<string, string>
  ids?: string[]
}

export async function loadAllRows(
  axios: AuthedAxiosRequests,
  endpoint: string,
  query: LotoLoadQuery
): Promise<unknown[]> {
  const response = await axios.post<unknown>(`${endpoint}/load`, {
    ...query,
    order_by: STABLE_ORDER,
    limit: null,
  })
  return rowsSchema.parse(response.data)
}
